import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ActivityTracker from '../components/ActivityTracker';
import { getAuthenticatedAccountId } from '../selectors/auth';
import api from '../api';

import {
  hideTrackerModals,
  showTrackerModal,
  showDietDiaperModal,
  showGrowthModal,
  showMilestoneModal,
  showActivitiesModal,
  showBasicModal,
  showSleepModal,
  showSaveEntryModal,
  showPreviousModal,
  showUnSavedModal
} from '../actions/ui';

function TrackerContainer(props) {
  return (
    <ActivityTracker {...props} />
  );
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      showTrackerModal,
      hideTrackerModals,
      showDietDiaperModal,
      showGrowthModal,
      showMilestoneModal,
      showActivitiesModal,
      showBasicModal,
      showSleepModal,
      showSaveEntryModal,
      showPreviousModal,
      showUnSavedModal,
      babiesList: api.actions.babiesList,
    },
    dispatch
  );

const mapStateToProps = state => {
  const {
    profile: { all: profiles },
    ui: {
      trackerModalShown,
      milestoneModalShown,
      dietDiaperModalShown,
      growthModalShown,
      activitiesModalShown,
      basicModalShown,
      sleepModalShown,
      saveEntryModalShown,
      unSavedModalShown
    }
  } = state;

  const accountId = state.auth.hasToken
    ? getAuthenticatedAccountId(state)
    : null;

  return {
    trackerModalShown,
    milestoneModalShown,
    dietDiaperModalShown,
    growthModalShown,
    activitiesModalShown,
    basicModalShown,
    sleepModalShown,
    saveEntryModalShown,
    unSavedModalShown,
    profiles,
    accountId
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackerContainer);
